@if(label()){
  <label class="f-small text-neutral-700 mb-1" for="selectUserId">{{label()}}</label>
}
<app-customised-multi-select
[autoGrow]="false"
[submitted]="submitted()"
id="selectUserId"
[options]="options()"
displayName="User"
[controls]="{control:control()}" [controlName]="'control'"
></app-customised-multi-select>
